import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import React, { FC, useState } from 'react';
import { Button, Dropdown, Paragraph } from '@digdir/designsystemet-react';
import { ChevronDownIcon, ChevronUpIcon } from '@navikt/aksel-icons';

import { camelCasify } from '../../../utils/navigation';
import { useUser } from '../../../hooks/useUser';
import { isValidBuildingTab } from '../utils';

export const DropDownMenu: FC<React.PropsWithChildren> = ({ children }) => {
  const { user } = useUser();
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  const tab = pathname.split('/').pop() ?? '';

  const currentPage = isValidBuildingTab(tab)
    ? t(`buildingScreen.tab.${camelCasify(tab)}.tabTitle`, {
        context: user?.type
      })
    : '-';

  return (
    <>
      <Button popovertarget="dropdown" variant={'secondary'}>
        <Paragraph>{currentPage}</Paragraph>
        {open ? <ChevronDownIcon aria-hidden /> : <ChevronUpIcon aria-hidden />}
      </Button>
      <Dropdown open={open} onClose={() => setOpen(false)} onOpen={() => setOpen(true)} id="dropdown">
        <Dropdown.List>{children}</Dropdown.List>
      </Dropdown>
    </>
  );
};
